import {
  AddressQuestion,
  BooleanQuestion,
  PhoneQuestion,
  Question,
  Questions,
} from '../../classes/question'
import { Countries } from '../../data'

export const getPCPQuestions = (
  customQuestions: Questions,
  hasGuarantor: boolean,
): Questions => [
  new BooleanQuestion({
    label: 'patient-intake.pcp-section.field-physician-question',
    key: 'hasPCP',
    required: true,
    ifQuestions: getQuestions(customQuestions, hasGuarantor),
    ifNoProceed: true,
  }),
]

// TODO: We actually can pull this info from PokitDok,
// it may make more sense to do this after the insurance collection
// and if we can pull it ask them to confirm their PCP otherwise have them
// enter it.

function getQuestions(
  customQuestions: Questions,
  hasGuarantor: boolean,
): Questions {
  return [
    new Question({
      label: 'patient-intake.pcp-section.field-pcp-name',
      key: 'pcpName',
      required: true,
      hint: hasGuarantor ? 'patient-intake.pcp-section.field-pcp-name-guarantor-hint' : 'patient-intake.pcp-section.field-pcp-name-hint',
      flex: '50',
    }),

    new PhoneQuestion({
      label: 'patient-intake.pcp-section.field-pcp-phone',
      key: 'pcpPhoneNumber',
      flex: '50',
      required: true,
    }),

    new Question({
      label: 'patient-intake.pcp-section.field-pcp-office',
      key: 'pcpOffice',
      hint: hasGuarantor ? 'patient-intake.pcp-section.field-pcp-office-guarantor-hint' : 'patient-intake.pcp-section.field-pcp-office-hint',
    }),

    new AddressQuestion({
      label: 'patient-intake.pcp-section.field-pcp-address',
      key: 'pcpAddress',
      options: Countries,
    }),

    ...customQuestions,
  ]
}
